var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneQueueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3.75C10.7433 3.75 9.14825 4.23385 7.79155 5.14038C6.43484 6.0469 5.37742 7.33537 4.753 8.84286C4.12857 10.3504 3.9652 12.0092 4.28353 13.6095C4.60185 15.2098 5.38759 16.6798 6.54137 17.8336C7.69516 18.9874 9.16516 19.7731 10.7655 20.0915C12.3659 20.4098 14.0246 20.2464 15.5321 19.622C17.0396 18.9976 18.3281 17.9402 19.2346 16.5835C20.1411 15.2267 20.625 13.6317 20.625 12C20.6227 9.81267 19.7528 7.71559 18.2061 6.16892C16.6594 4.62225 14.5623 3.75231 12.375 3.75ZM16.8173 12.6346H12.375C12.2067 12.6346 12.0453 12.5678 11.9263 12.4487C11.8072 12.3297 11.7404 12.1683 11.7404 12V7.55769C11.7404 7.38938 11.8072 7.22796 11.9263 7.10895C12.0453 6.98994 12.2067 6.92308 12.375 6.92308C12.5433 6.92308 12.7047 6.98994 12.8237 7.10895C12.9428 7.22796 13.0096 7.38938 13.0096 7.55769V11.3654H16.8173C16.9856 11.3654 17.147 11.4322 17.266 11.5513C17.3851 11.6703 17.4519 11.8317 17.4519 12C17.4519 12.1683 17.3851 12.3297 17.266 12.4487C17.147 12.5678 16.9856 12.6346 16.8173 12.6346Z",
    fill: "#74D1EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneQueueIcon);
export default __webpack_public_path__ + "static/media/MilestoneQueueIcon.36bddd3fbb4c31696cd6778cf6f63f06.svg";
export { ForwardRef as ReactComponent };